<template>
  <div>
    <div align="right">
      <el-button type="primary" size="mini" @click="dialogVisible = true">
        Add Inventory
      </el-button>
    </div>
    <el-dialog title="Add Inventory" :visible.sync="dialogVisible">
      <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit">
        <el-form-item label="Distributor" prop="distributor">
          <app-distributors v-model="form.distributor" />
        </el-form-item>
        <el-form-item label="SKU" prop="sku">
          <el-input v-model="form.sku"></el-input>
        </el-form-item>
        <el-row :gutter="15">
          <el-col :xs="24" :sm="12">
            <el-form-item label="Price" prop="price">
              <el-input v-model="form.price" class="input-select">
                <el-select v-model="form.currency" slot="append" placeholder="Select currency">
                  <el-option label="MYR" value="MYR"></el-option>
                  <el-option label="SGD" value="SGD"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="Available stock" prop="stockAvailable">
              <el-input v-model="form.stockAvailable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :xs="24" :sm="8">
            <el-form-item label="Discount begin" prop="discountPrice">
              <el-date-picker v-model="form.discountBegin" type="date"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="Discount end" prop="discountPrice">
              <el-date-picker v-model="form.discountEnd" type="date"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="Discount price" prop="discountPrice">
              <el-input-number v-model="form.discountPrice" :precision="2" :step="1"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
        <el-button @click="onCancel">Cancel</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import AppDistributors from '@/components/App/AppDistributors'

export default {
  components: {
    AppDistributors,
  },

  props: {
    variantId: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        distributor: null,
        condition: 'new',
        currency: 'MYR',
        discountBegin: null,
        discountEnd: null,
        discountPrice: 0,
        price: 0,
        sku: null,
        stockAvailable: 0,
      },
      rules: {
        'distributor': [
          { required: true, message: 'Select a distributor.', trigger: 'blur' },
        ],
        'condition': [
          { required: true, message: 'Select a product condition.', trigger: 'blur' },
        ],
        'price': [
          { required: true, message: 'Enter a product price.', trigger: 'blur' },
        ],
        'sku': [
          { required: true, message: 'Enter the product identifier.', trigger: 'blur' },
        ],
        'stockAvailable': [
          { required: true, message: 'Enter the available stock.', trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    onSubmit() {
      this.loading = true

      this.$refs['form'].validate(async valid => {
        if (!valid) {
          this.loading = false
          return false
        }

        try {
          var { data } = await this.$http.post(`/inventories`, {
            distributor_id: this.form.distributor,
            condition: this.form.condition,
            currency: this.form.currency,
            discount_begin: this.form.discountBegin,
            discount_end: this.form.discountEnd,
            discount_price: this.form.discountPrice,
            price: this.form.price,
            variant_id: this.variantId,
            sku: this.form.sku,
            stock_available: this.form.stockAvailable,
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.dialogVisible = false
        this.$refs['form'].resetFields()
        this.form.distributor = null
        this.$emit('create')
        this.$message.success(data.message)
      })
    },

    onCancel() {
      this.dialogVisible = false
      this.form.distributor = null
      this.$refs['form'].resetFields()
    },
  },
}
</script>

<style>
.input-select .el-input-group__append {
  width: 100px;
  padding: 0;
}

.input-select .el-select {
  margin: -10px 0;
  text-align: right;
}
</style>
